var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108.846,
    height: 151.406,
    viewBox: "0 0 108.846 151.406",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#deb89a;}.b{fill:#794832;}.c{fill:#e74444;}.d{fill:#d81212;}.e{fill:#2b4d66;}.f{fill:#ac0101;}.g{fill:#f5cbaa;}.h{fill:#93573d;}.i{fill:#a7160a;}.j{fill:#810c02;}.k{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-156.392 -55.094)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M264,192h10.309v23.2H264Z",
    transform: "translate(-57.192 -82.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M305.505,56.5V44.618A20.618,20.618,0,0,0,284.887,24h-2.577A10.309,10.309,0,0,0,272,34.309V49.773A30.928,30.928,0,0,0,302.928,80.7h2.577c15.464,0,15.464-12.887,15.464-12.887l-6.85-1.141A10.309,10.309,0,0,1,305.505,56.5Z",
    transform: "translate(-62.615 31.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M217.67,289.237H112l19.716-31.546a20.629,20.629,0,0,1,16.395-9.662c.361-.019.725-.029,1.089-.029h11.769l5.155,5.155L171.278,248h11.137c.564,0,1.121.023,1.675.074a20.6,20.6,0,0,1,16.3,10.435Z",
    transform: "translate(45.839 -120.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M176.481,308.813,112,289.237l19.716-31.546a20.626,20.626,0,0,1,16.24-9.652l.155-.01c.361-.019.725-.029,1.089-.029h11.769l5.155,5.155L171.278,248h11.137c.564,0,1.121.023,1.675.074l.216.019a20.6,20.6,0,0,1,16.079,10.416l17.461,30.728-9.334,4.417Z",
    transform: "translate(45.839 -120.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M238.124,328H191.732L184,346.041v33.505h61.855V346.041Z",
    transform: "translate(-2.965 -174.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M331.05,276.241a2.574,2.574,0,0,1-3.209-1.727l-7.732-25.773A2.58,2.58,0,0,1,320,248h3.405c.564,0,1.121.023,1.675.074l.216.019,7.481,24.939A2.577,2.577,0,0,1,331.05,276.241Z",
    transform: "translate(-95.151 -120.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M212.921,248a2.581,2.581,0,0,1-.11.741l-7.732,25.773a2.577,2.577,0,0,1-4.936-1.482l7.5-24.993.155-.01c.361-.019.725-.029,1.089-.029Z",
    transform: "translate(-13.845 -120.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M7.29,0,30.043,9.059,28.1,22.674A5.155,5.155,0,0,1,23,27.1H9.425L0,7.29Z",
    transform: "translate(234.221 189.409) rotate(-82)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 20.618,
    height: 15.464,
    rx: 7.732,
    transform: "translate(217.039 192.331) rotate(-37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M224,104h36.082v20.618a15.464,15.464,0,0,1-15.464,15.464h-5.155A15.464,15.464,0,0,1,224,124.619Z",
    transform: "translate(-30.079 -23.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M242.1,253.155l-5.155,7.732L224.09,248.029c.361-.019.725-.029,1.089-.029h11.769Z",
    transform: "translate(-30.14 -120.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M297.967,248.074l-12.812,12.812L280,253.155,285.155,248h11.137c.564,0,1.121.023,1.675.074Z",
    transform: "translate(-68.038 -120.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M257.237,79.464V94.928l-4.8-.6h0c-12.265-3.135-18.4-17.442-18.4-17.442S228.887,89.773,216,89.773V79.464A15.464,15.464,0,0,1,231.464,64h10.309A15.464,15.464,0,0,1,257.237,79.464Z",
    transform: "translate(-24.656 3.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M22.753,0,0,9.059,1.945,22.674a5.155,5.155,0,0,0,5.1,4.426h13.57L30.043,7.29Z",
    transform: "matrix(0.087, 0.996, -0.996, 0.087, 183.389, 160.908)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "g",
    width: 20.619,
    height: 15.464,
    rx: 7.732,
    transform: "matrix(-0.766, -0.643, 0.643, -0.766, 193.072, 206.5)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 18.569,
    cy: 17.721,
    rx: 18.569,
    ry: 17.721,
    transform: "translate(189.433 171.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M243.062,128.917a19.66,19.66,0,0,0-2.062.109c9.4,1,16.506,8.586,16.506,17.612S250.4,163.247,241,164.249a19.652,19.652,0,0,0,2.062.109c10.255,0,18.569-7.934,18.569-17.721s-8.314-17.721-18.569-17.721Z",
    transform: "translate(-35.061 42.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M14.908,13.213l5.169-5.157A1.207,1.207,0,1,0,18.37,6.349l-5.157,5.169L8.057,6.349A1.207,1.207,0,1,0,6.35,8.056l5.169,5.157L6.35,18.37a1.207,1.207,0,1,0,1.707,1.707l5.157-5.169,5.157,5.169a1.207,1.207,0,1,0,1.707-1.707Z",
    transform: "translate(194.076 176.34)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus5);
export default __webpack_public_path__ + "static/media/status-5.86f5b015a307980a64035683197ec8cd.svg";
export { ForwardRef as ReactComponent };